import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "locale-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass({
        'active-color': _ctx.$i18n.locale === 'ru',
        'visited-color': _ctx.$i18n.locale !== 'ru',
      }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchLocale('ru')))
    }, "Русский язык", 2),
    _createElementVNode("a", {
      class: _normalizeClass({
        'active-color': _ctx.$i18n.locale === 'kz',
        'visited-color': _ctx.$i18n.locale !== 'kz',
      }),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchLocale('kz')))
    }, "Қазақ тілі", 2),
    _createElementVNode("a", {
      class: _normalizeClass({
        'active-color': _ctx.$i18n.locale === 'en',
        'visited-color': _ctx.$i18n.locale !== 'en',
      }),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchLocale('en')))
    }, "English", 2)
  ]))
}